// Iter 213 — ✏️ Auto-édition des informations par l'adhérent (Espace Adhérent).
// Tél/email : direct. Nom/prénom : verrous avion J-60 / bus 48h. Date de naissance : validation admin.
import React, { useEffect, useState } from 'react';
import DemandeParticipant from './espace/DemandeParticipant';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FicheInfosBlock = ({ token, regId }) => {
  const [infos, setInfos] = useState(null);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');

  const charger = async () => {
    const r = await fetch(`${API}/espace-adherent/${token}/fiche/${regId}/infos`);
    if (r.ok) { setInfos(await r.json()); setOpen(true); }
  };

  // Iter 574 — ouverture via l'ancre #fiche-infos-{regId} (lien « Compléter → » du dossier avion)
  useEffect(() => {
    const ouvrirSiAncre = () => { if (window.location.hash === `#fiche-infos-${regId}` && !open) charger(); };
    ouvrirSiAncre();
    window.addEventListener('hashchange', ouvrirSiAncre);
    return () => window.removeEventListener('hashchange', ouvrirSiAncre);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regId]);

  if (!open) {
    return (
      <button id={`fiche-infos-${regId}`} onClick={charger} data-testid={`fiche-infos-btn-${regId}`}
        className="text-xs font-bold px-3 py-2 rounded-lg bg-sky-100 text-[#1E3A5F] hover:bg-sky-200 border border-sky-300">
        ✏️ Vérifier / modifier mes informations
      </button>
    );
  }
  if (!infos) return null;

  return (
    <div id={`fiche-infos-${regId}`} className="bg-sky-50 border border-sky-200 rounded-xl p-3 space-y-2.5" data-testid={`fiche-infos-${regId}`}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-bold text-[#1E3A5F]">✏️ Mes informations</p>
        <button onClick={() => setOpen(false)} className="text-xs text-sky-700 font-bold">✕ Fermer</button>
      </div>
      {infos.lock.verrouille && (
        <p className="text-[11px] bg-amber-50 border border-amber-200 rounded-lg p-2 text-amber-800 font-semibold" data-testid={`fiche-infos-lock-${regId}`}>
          🔒 {infos.lock.message}
        </p>
      )}
      {!infos.lock.verrouille && infos.lock.limite && (
        <p className="text-[10px] text-sky-800">
          ℹ️ Noms et prénoms modifiables jusqu'à <strong>{infos.lock.limite}</strong> avant le départ. Une nouvelle date de naissance qui change la catégorie tarifaire (bébé / moins de 12 ans / mineur / adulte) est soumise à validation de l'association.
        </p>
      )}
      <DemandeParticipant token={token} regId={regId} />
      {(infos.demandes_en_attente || []).map(d => (
        <p key={d.id} className="text-[11px] bg-purple-50 border border-purple-200 rounded-lg p-2 text-purple-800" data-testid={`fiche-demande-${d.id}`}>
          ⏳ Date de naissance de <strong>{d.voyageur_nom}</strong> ({d.avant} → {d.apres}) : en attente de validation par l'association.
        </p>
      ))}
      {msg && <p className="text-[11px] bg-emerald-50 border border-emerald-200 rounded-lg p-2 text-emerald-800 font-semibold" data-testid={`fiche-infos-msg-${regId}`}>{msg}</p>}
      <ContactForm token={token} regId={regId} infos={infos} onDone={(m) => { setMsg(m); charger(); }} />
      {infos.lieu_depart?.concerne && <LieuDepartForm key={`${infos.lieu_depart.actuel}|${infos.lieu_depart.aire}`} token={token} regId={regId} info={infos.lieu_depart} onDone={(m) => { setMsg(m); charger(); }} />}
      {infos.is_avion && (
        <p className="text-[11px] bg-red-50 border border-red-200 rounded-lg p-2 text-red-800 font-semibold" data-testid={`fiche-avion-warning-${regId}`}>
          ✈️ <strong>Voyage en avion :</strong> toute modification des noms, prénoms et dates de naissance se fait
          <strong> sous votre responsabilité</strong> — ils doivent correspondre <strong>exactement</strong> à la pièce
          d'identité qui sera fournie à la compagnie aérienne.
        </p>
      )}
      {infos.voyageurs.map(v => (
        <VoyageurForm key={v.index} token={token} regId={regId} v={v} lock={infos.lock}
          onDone={(m) => { setMsg(m); charger(); }} />
      ))}
      {(infos.chambres || []).filter(c => c.typeChambre && c.typeChambre !== 'individuelle').map(c => (
        <ChambreForm key={c.index} token={token} regId={regId} c={c}
          onDone={(m) => { setMsg(m); charger(); }} />
      ))}
    </div>
  );
};

const LITERIES = ['1 grand lit', '2 lits séparés', '3 lits séparés', '4 lits séparés'];
const LITERIES_PAR_OCCUPANTS = { 2: ['1 grand lit', '2 lits séparés'], 3: ['3 lits séparés'], 4: ['4 lits séparés'] };
const TYPE_LABELS = { 'grand-lit': '1 grand lit', '2-lits': '2 lits séparés', '3-lits': '3 lits séparés', '4-lits': '4 lits séparés', 'individuelle': 'individuelle' };

const ChambreForm = ({ token, regId, c }) => (
  <div className="bg-white border border-sky-100 rounded-lg p-2.5" data-testid={`chambre-form-${regId}-${c.index}`}>
    <p className="text-[11px] font-bold text-[#1E3A5F] mb-1">
      🛏️ Chambre {c.index + 1} ({TYPE_LABELS[c.typeChambre] || c.typeChambre}){c.occupants.length > 0 ? ` — ${c.occupants.join(', ')}` : ''}
    </p>
    <p className="text-xs text-gray-700 font-semibold">Literie : {c.literie || '— À préciser —'}</p>
    <p className="text-[10px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 mt-1" data-testid={`chambre-literie-bloquee-${regId}-${c.index}`}>
      🔒 Pour toute modification de literie (lit bébé, configuration de chambre…), contacte directement l'association — c'est nous qui effectuons la modification.{' '}
      <a href="https://wa.me/33660416218" target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center gap-1 font-bold text-emerald-700 underline"
        data-testid={`chambre-literie-whatsapp-${regId}-${c.index}`}>
        💬 WhatsApp 06 60 41 62 18
      </a>
    </p>
  </div>
);

const Champ = ({ label, value, onChange, testId, placeholder }) => (
  <label className="text-[10px] font-bold text-gray-500">{label}
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder || ''}
      className="w-full border rounded px-2 py-1.5 text-xs mt-0.5" data-testid={testId} />
  </label>
);

// Iter 746 (Kamel) — lieu de départ du car modifiable par l'adhérent jusqu'à 48 h avant le départ (toute la fiche)
const LieuDepartForm = ({ token, regId, info, onDone }) => {
  const [lieu, setLieu] = useState(info.actuel || '');
  const [aire, setAire] = useState(info.aire || '');
  const [busy, setBusy] = useState(false);
  if (!info || !info.concerne) return null;
  const dirty = lieu !== (info.actuel || '') || (lieu === 'autoroute' && aire !== (info.aire || ''));
  const save = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/fiche/${regId}/lieu-depart`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ lieu, aire }),
      });
      const j = await r.json();
      if (!r.ok) alert(j.detail || 'Erreur');
      else onDone('✅ Lieu de départ mis à jour pour toutes les personnes de cette fiche.');
    } catch (e) { alert('Erreur réseau'); }
    setBusy(false);
  };
  return (
    <div className="bg-white border border-sky-100 rounded-lg p-2.5 space-y-1.5" data-testid={`fiche-lieu-depart-${regId}`}>
      <p className="text-[11px] font-bold text-[#1E3A5F]">🚌 Lieu de départ du car <span className="font-normal text-gray-500">— pour toutes les personnes de la fiche</span></p>
      {info.modifiable
        ? <p className="text-[10px] text-sky-800">Modifiable en ligne jusqu'à <strong>48 h avant le départ</strong>{info.limite ? <> (soit le <strong>{info.limite}</strong>)</> : null}. Passé ce délai, contactez l'association.</p>
        : <p className="text-[10px] bg-amber-50 border border-amber-200 rounded p-1.5 text-amber-800 font-semibold" data-testid={`fiche-lieu-depart-lock-${regId}`}>🔒 Plus modifiable en ligne (moins de 48 h avant le départ). Un changement ? WhatsApp <strong>06 60 41 62 18</strong>.</p>}
      {info.options.map(o => (
        <label key={o.code} className={`flex items-start gap-2 text-[11px] rounded-lg border px-2 py-1.5 ${info.modifiable ? 'cursor-pointer' : 'opacity-70'} ${lieu === o.code ? 'border-[#1E3A5F] bg-sky-50' : 'border-gray-200'}`}>
          <input type="radio" name={`lieu-depart-${regId}`} checked={lieu === o.code} disabled={!info.modifiable} onChange={() => setLieu(o.code)}
            className="mt-0.5 accent-[#1E3A5F]" data-testid={`fiche-lieu-depart-${o.code}-${regId}`} />
          <span>{o.label}</span>
        </label>
      ))}
      {lieu === 'autoroute' && (
        <div className="ml-6 space-y-1">
          <input value={aire} disabled={!info.modifiable} onChange={e => setAire(e.target.value.toUpperCase())} placeholder="NOM DE L'AIRE (EX. AIRE DE MONTÉLIMAR)"
            className="w-full border rounded px-2 py-1.5 text-xs" data-testid={`fiche-lieu-depart-aire-${regId}`} />
          <p className="text-[10px] text-amber-800 italic">Prise en charge <strong>uniquement sur une aire d'autoroute A7 / A9</strong> située sur le trajet du car (voyages Espagne). L'horaire de passage vous sera précisé le plus tôt possible.</p>
        </div>
      )}
      {dirty && info.modifiable && (
        <button onClick={save} disabled={busy || (lieu === 'autoroute' && !aire.trim())} data-testid={`fiche-lieu-depart-save-${regId}`}
          className="w-full text-xs font-bold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">
          {busy ? '…' : '💾 Enregistrer le lieu de départ'}
        </button>
      )}
    </div>
  );
};

const ContactForm = ({ token, regId, infos, onDone }) => {
  const [tel, setTel] = useState(infos.telephone);
  const [email, setEmail] = useState(infos.email);
  const [adresse, setAdresse] = useState(infos.adresse || '');
  const [busy, setBusy] = useState(false);
  const dirty = tel !== infos.telephone || email !== infos.email || adresse !== (infos.adresse || '');
  const save = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/fiche/${regId}/infos`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telephone: tel, email, adresse }),
      });
      const j = await r.json();
      if (!r.ok) alert(j.detail || 'Erreur');
      else onDone('✅ Coordonnées mises à jour.');
    } catch (e) { alert('Erreur réseau'); }
    setBusy(false);
  };
  return (
    <div className="bg-white border border-sky-100 rounded-lg p-2.5 grid grid-cols-2 gap-2 items-end" data-testid={`fiche-contact-form-${regId}`}>
      <p className="col-span-2 text-[11px] font-bold text-[#1E3A5F]">📇 Coordonnées de la fiche</p>
      <Champ label="Téléphone" value={tel} onChange={setTel} testId={`fiche-contact-tel-${regId}`} />
      <Champ label="Email" value={email} onChange={setEmail} testId={`fiche-contact-email-${regId}`} />
      <div className="col-span-2">
        <Champ label="Adresse postale (n°, rue, code postal, ville)" value={adresse} onChange={setAdresse}
          placeholder="Ex : 12 rue de la République, 69200 Vénissieux" testId={`fiche-contact-adresse-${regId}`} />
      </div>
      {dirty && (
        <button onClick={save} disabled={busy} data-testid={`fiche-contact-save-${regId}`}
          className="col-span-2 text-xs font-bold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">
          {busy ? '…' : '💾 Enregistrer mes coordonnées'}
        </button>
      )}
    </div>
  );
};

const VoyageurForm = ({ token, regId, v, lock, onDone }) => {
  const [f, setF] = useState({ nom: v.nom, prenom: v.prenom, dateNaissance: v.dateNaissance });
  const [busy, setBusy] = useState(false);
  const dirty = f.nom !== v.nom || f.prenom !== v.prenom || f.dateNaissance !== v.dateNaissance;
  const identiteLocked = lock.verrouille;
  const save = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/fiche/${regId}/voyageur/${v.index}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(f),
      });
      const j = await r.json();
      if (!r.ok) alert(j.detail || 'Erreur');
      else onDone(j.demande_en_attente ? j.message_demande : '✅ Informations mises à jour.');
    } catch (e) { alert('Erreur réseau'); }
    setBusy(false);
  };
  return (
    <div className="bg-white border border-sky-100 rounded-lg p-2.5 grid grid-cols-2 gap-2" data-testid={`voyageur-form-${regId}-${v.index}`}>
      <p className="col-span-2 text-[11px] font-bold text-[#1E3A5F]">
        👤 Voyageur {v.index + 1} — {v.prenom} {v.nom} {identiteLocked && (v.nom || v.prenom) && <span className="text-amber-600">🔒 nom/prénom verrouillés</span>}
      </p>
      <Champ label={`Nom${identiteLocked && v.nom ? ' 🔒' : ''}`} value={f.nom} onChange={val => setF(x => ({ ...x, nom: val }))} testId={`voyageur-nom-${regId}-${v.index}`} />
      <Champ label={`Prénom${identiteLocked && v.prenom ? ' 🔒' : ''}`} value={f.prenom} onChange={val => setF(x => ({ ...x, prenom: val }))} testId={`voyageur-prenom-${regId}-${v.index}`} />
      <Champ label={`Date de naissance (JJ/MM/AAAA)${v.dateNaissance ? ' — soumise à validation' : ''}`} value={f.dateNaissance}
        onChange={val => setF(x => ({ ...x, dateNaissance: val }))} placeholder="JJ/MM/AAAA" testId={`voyageur-ddn-${regId}-${v.index}`} />
      {dirty && (
        <button onClick={save} disabled={busy} data-testid={`voyageur-save-${regId}-${v.index}`}
          className="col-span-2 text-xs font-bold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">
          {busy ? '…' : '💾 Enregistrer ce voyageur'}
        </button>
      )}
    </div>
  );
};

export default FicheInfosBlock;
